<ng-template #loginModal let-modal>

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Login</h4>
    <button type="button" class="btn-close" aria-label="Close" title="Close Modal"
      (click)="modal.dismiss('Cross click'); fromReset(); handleCloseClick()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formGroup">
      <h5 class="modal-info-text">Glad to see you back!</h5>

      <div class="row modal-form-row">
        <div class="col-12">
          <div>
            <app-input [inputType]="'email'" [fieldValue]="item.email" [fieldText]="'email'"
                       [fControl]="formGroup.controls['Email']" [inputClass]="'form-control'" [inputPlaceholder]="'Enter Email'"
                       [inputLabel]="'Email'" [labelClass]="'form-label'" (onTextChange)="onTextValueChange($event)"
                       [patternValidationMsg]="'Email is invalid'" (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
        </div>
        <div class="col-12">
          <div>
            <app-input-password [fieldValue]="item.password" [fieldText]="'password'"
                                [fControl]="formGroup.controls['Password']" [inputClass]="'form-control'" [inputLabel]="'Password'"
                                [labelClass]="'form-label'" [inputPlaceholder]="'Enter Password'"
                                (onTextChange)="onTextValueChange($event)" (keyup.enter)="onClick()"
                                (keydown.tab)="$event.preventDefault()" (keyup.tab)="onClick()"></app-input-password>
          </div>
        </div>
        <div class="forgot-pass-block">
          <a href="#" type="button"
             (click)="openModal(forgotPasswordComponent.forgotPasswordTemplate, 'forgot-password-modal')"
             (click)="modal.close('Close click')" class="primary-link" title="Forgot Password?">
            Forgot Password?
          </a>
        </div>
        <div class="btn-grps">
          <app-button [btnType]="'submit'" [id]="'login-btn'" [btnText]="'Login'" [btnTitle]="'Login'"
                      [btnCss]="'btn btn-primary w-100 btn-lg'" [isDisable]="isDisableLoginBtn"
                      (onBtnClick)="onClick()"></app-button>
        </div>
        <div class="social-login">
          <p>or continue with</p>
          <div class="social-icons">
            <a href="#" class="social-icon google" (click)="$event.preventDefault(); loginWithGoogle()" aria-label="Google Login">
              <img src="./assets/images/google.svg" alt="Google" />
            </a>
            <a href="#" class="social-icon facebook" (click)="$event.preventDefault(); loginWithFacebook()" aria-label="Facebook Login">
              <img src="./assets/images/facebook.svg" alt="Facebook" />
            </a>
            <a href="#" class="social-icon instagram" (click)="$event.preventDefault(); loginWithInstagram()" aria-label="Instagram Login">
              <img src="./assets/images/instagram.svg" alt="Instagram" />
            </a>
            <a href="#" class="social-icon apple" (click)="$event.preventDefault(); loginWithApple()" aria-label="Apple Login">
              <img src="./assets/images/apple.svg" alt="Apple" />
            </a>
          </div>
        </div>
        <div class="create-act-block">
          <h5>
            Don’t have an account?&nbsp;<a href="#" title=" Sign Up" class="primary-link"
                                           (click)="$event.preventDefault(); openSignUpModal(signUpComponent.signupTemplate, 'sign-in-modal', modal);">
              Sign
              Up
            </a>
          </h5>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<app-forgotpassword #forgotPasswordModal [modalRef]="modalReference"></app-forgotpassword>
<app-signup #signUpModal></app-signup>
